<template>
  <b-card>
    <b-tabs >
      <b-tab title="Almoxarifado">
        <AlmoxarifadoTab  />
      </b-tab>
      <b-tab title="Patrimônio">
        <PatrimonioTab  />
      </b-tab>
      <b-tab title="Administrador">
        <AdministradorTab  />
      </b-tab>
      <b-tab title="Unidade Administrativa">
        <UnidadeAdministrativaTab  />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import PatrimonioTab from "@/modules/administrador/painel-de-configuracao/patrimonio/PatrimonioTab.vue";
import AdministradorTab from "@/modules/administrador/painel-de-configuracao/administrador/AdministradorTab.vue";
import AlmoxarifadoTab from "@/modules/administrador/painel-de-configuracao/almoxarifado/AlmoxarifadoTab.vue";
import UnidadeAdministrativaTab
  from "@/modules/administrador/painel-de-configuracao/unidadeadministrativa/UnidadeAdministrativaTab.vue";

export default {
  components: {
    PatrimonioTab,
    AdministradorTab,
    AlmoxarifadoTab,
    UnidadeAdministrativaTab

  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style lang="scss">
a {
  color: #292d32;
}


</style>
